// ES6 syntax to extend jQuery with plugins
let $ = require('jquery');
// TODO: Comentada la validación de jQuery para que no moleste más. En un futuro eliminar del todo
// $ = require('jquery-validation');
//

//
require('../../../../node_modules/jquery-validation/dist/localization/messages_es.js');
require('../../../../node_modules/jquery-validation/dist/additional-methods.js');


$(document).ready(function() {
  const $body = $('html, body');
  const $processSteps = $('.m-process-steps');

  if ($processSteps.length === 0) {
    return;
  }

  //// Forms ////
  const $forms = $processSteps.find('form');
  const $steps = $processSteps.find('.step');

  $forms.each(function() {
    const $form = $(this);
    const action = $form.attr('action');
    const method = $form.attr('method');
    const $stepBack = $form.find('.step-back');

    //
    //$stepBack.on('click', function(event) {
    //  event.preventDefault();
    //  const $thisStep = $processSteps.find('.step.active');
    //  const $prevStep = $thisStep.prev('.step');
    //  const $header = $body.find('.m-header-checkout');

    //  $thisStep.removeClass('active');
    //  $prevStep.addClass('active');

    //  if($prevStep.length > 0) {
    //    $body.animate({
    //      scrollTop: $prevStep.offset().top - $header.height() - 20
    //    }, 600);
    //  }
    //});


    //
    // const $validator = $form.validate({
    //   lang: 'es',
    //   rules: {
    //     'confirm-email': {
    //       equalTo: '#email'
    //     },
    //     'confirm-password': {
    //       equalTo: '#password'
    //     },
    //     mobile: 'number',
    //     phone: 'number',
    //     'bank-account': {
    //       iban: true,
    //       required: () =>  $('#bank-account').closest('.tab-content').hasClass('active')
    //     },
    //     'new-address-line': {
    //       required: '#new-address:checked'
    //     },
    //     'new-city': {
    //       required: '#new-address:checked'
    //     },
    //     'new-region': {
    //       required: '#new-address:checked'
    //     },
    //     'new-postal-code': {
    //       required: '#new-address:checked'
    //     },
    //     'new-country': {
    //       required: '#new-address:checked'
    //     },
    //     'nif': {
    //       required: '#i-am-company:unchecked'
    //     },
    //     'company-name': {
    //       required: '#i-am-company:checked'
    //     },
    //     'company-id': {
    //       required: '#i-am-company:checked'
    //     }
    //   },
    //   submitHandler: function(form) {
    //     const $thisStep = $processSteps.find('.step.active');
    //     const $nextStep = $thisStep.next('.step');
    //     const $header = $body.find('.m-header-checkout');
    //     const redirectTo = $form.attr('data-redirect-to');

    //     if ($form.hasClass('js-ajax')) {
    //       const data = $form.serialize();

    //       $.ajax({
    //         data,
    //         method,
    //         url: action,
    //         success: function(response) {
    //           if (response.status === 'success') {
    //             $thisStep.removeClass('active');
    //             $nextStep.addClass('active');

    //             if($nextStep.length > 0) {
    //               $body.animate({
    //                 scrollTop: $nextStep.offset().top - $header.height() - 20
    //               }, 600);
    //             }
    //             else {
    //               window.location = redirectTo;
    //             }
    //           }
    //           else if (response.status === 'fail') {
    //             $validator.showErrors(response.data.errors);
    //           }
    //         },
    //       });

    //       return false;
    //     }
    //     else {
    //       return true;
    //     }
    //   }
    // });
  });

  //// Step plans ////
  //const $stepPlans = $('.step-plans');
  //const $plans = $stepPlans.find('.e-box');

  //const countPlans = () => {
  //  const $plans = $stepPlans.find('.e-box');
  //  return $plans.length;
  //}

  //$plans.each(function() {
  //  const $plan = $(this);
  //  const id = $plan.attr('data-plan');
  //  const $close = $plan.find('.close a');
  //  const deleteUrl = $close.attr('href');

  //  $close.click((event) => {
  //    event.preventDefault();
  //    $plan.fadeOut(400, function() {
  //      $plan.remove();

  //      // Remove close button when there's only one plan
  //      if (countPlans() === 1) {
  //        $plans.find('.close').hide();
  //      }
  //    });

  //    $.ajax({
  //      data: { id },
  //      method: 'get',
  //      url: deleteUrl
  //    });
  //  });
  //});

  //// Step plates ////
  const $stepPlates = $('.step-plates');
  const $plateItaly = $stepPlates.find('.plate-italy');

  $plateItaly.each(function() {
    const $thisItaly = $(this);
    const $radioButtons = $thisItaly.find('input');
    const $showInfoRadioButton = $thisItaly.find('input.show-info');
    const $info = $thisItaly.find('.plate-info');

    $radioButtons.on('change', () => {
      if ($showInfoRadioButton.is(':checked')) {
        $info.addClass('show');
      }
      else {
        $info.removeClass('show');
      }
    });
  });

  //// Step client data ////
  const $stepClientData = $('.step-client-data');
  const $companyCheckbox = $stepClientData.find('.e-switch input');
  const $companyData = $stepClientData.find('.company-data');
  const $personData = $stepClientData.find('.person-data');

  // Tabs effect for my address summary / new address form
  if ($stepClientData.length > 0) {
    $companyCheckbox.on('change', () => {
      const value = $stepClientData.find('.e-switch input').is(':checked');
      if (value) {
        $companyData.slideDown();
        $personData.slideUp();
      }
      else {
        $companyData.slideUp();
        $personData.slideDown();
      }
    });
  }

  //// Step summary ////
  const $stepSummary = $('.step-summary');
  const $radioAddress = $stepSummary.find('.e-radiobutton input');
  const $summaryAddress = $stepSummary.find('.summary-address');

  // Tabs effect for my address summary / new address form
  if ($stepSummary.length > 0) {
    $radioAddress.on('change', () => {
      const value = $stepSummary.find('.e-radiobutton input:checked').val();
      $summaryAddress.find('> .active').removeClass('active');
      $summaryAddress.find(`.${value}`).addClass('active');
    });
  }
});



// WEBPACK FOOTER //
// ./app/ui/modules/process-steps/index.js